import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiHtml5 ,
  DiCss3 ,
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiGit,
  DiRedis
} from "react-icons/di";
import {
  SiTailwindcss ,
   SiBootstrap ,
   SiTypescript ,
   SiNextdotjs ,
  SiFirebase,
  SiExpress 
} from "react-icons/si";
import { FaAws } from "react-icons/fa";


function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
      <DiHtml5 />
      </Col>
         <Col xs={4} md={2} className="tech-icons">
      <DiCss3 />
      </Col>
     
      <Col xs={4} md={2} className="tech-icons">
       <SiTailwindcss />
      </Col>
        <Col xs={4} md={2} className="tech-icons">
        < SiBootstrap  />
      </Col>
          <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <SiTypescript />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>
         <Col xs={4} md={2} className="tech-icons">
        <SiNextdotjs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs/>
      </Col>
          <Col xs={4} md={2} className="tech-icons">
        <SiExpress />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <DiRedis />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb />
      </Col>
   
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFirebase />
      </Col>
         <Col xs={4} md={2} className="tech-icons">
        
    <FaAws />
      </Col>



    </Row>
  );
}

export default Techstack;
